import { ConfigColuna } from "components/ModalConfigColunas";

// Configuração das colunas da tabela "Itens para pagamento" (tela do lote).
// ID e Ações ficam sempre visíveis (não entram na configuração).
export const CHAVE_CONFIG_COLUNAS_LOTE = "config_taxa_sp_itens_lote_colunas";

export const defaultConfigColunasLote: ConfigColuna[] = [
  { nome: "placa", exibir: true },
  { nome: "renavam", exibir: true },
  { nome: "empresa", exibir: true },
  { nome: "clienteFinal", exibir: true },
  { nome: "cpfCnpj", exibir: true },
  { nome: "uf", exibir: true },
  { nome: "tipoPgto", exibir: true },
  { nome: "status", exibir: true },
  { nome: "valor", exibir: true },
  { nome: "pagamento", exibir: true },
];

export const colunaLabelsLote: Record<string, string> = {
  placa: "PLACA",
  renavam: "RENAVAM",
  empresa: "EMPRESA",
  clienteFinal: "CLIENTE FINAL",
  cpfCnpj: "CPF/CNPJ",
  uf: "UF ORIGEM",
  tipoPgto: "TIPO DE PGTO",
  status: "STATUS",
  valor: "VALOR",
  pagamento: "PAGAMENTO",
};
